import React, {useEffect, useState} from "react";
import {connect} from 'react-redux'
import Form from 'components/Form';
import {withRouter} from "react-router";
import {DemandValidation, DemandValidationKeys} from 'constants/DemandValidation';
import ValidationShema from "constants/ValidationShema";
import Loading from "components/Loading";
import ResultNoticeService from "services/ResultNoticeService";
import AttachmentResultNotice from "./components/AttachmentResultNotice";
import OjsResultNotice from "./components/OjsResultNotice";
import ResultNoticeType from "./constants/ResultNoticeType";
import DemandValidationMessages from "components/DemandValidationMessages";
import makeStyles from "@material-ui/core/styles/makeStyles";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import Tr from "translations/Translations";
import AddBzpResultNoticePopup from "components/complex/documentsTables/swz/AddBzpResultNoticePopup";
import RouterPath from "libs/RouterPath";
import BzpResultNotice from "./components/BzpResultNotice";
import NationalNoticeService from "../../../../../../../services/NationalNoticeService";

const useStyles = makeStyles(() => ({
    root: {
        width: '100%'
    }
}))

function ResultNoticePanel(
    {
        match,
        demandValidation,
        bzpTenderResultNoticeStatus,
        resultNotices
    }) {

    const classes = useStyles();
    const demandId = match.params.id;

    const currentDemandValidation = DemandValidation.RESULT_NOTICE;
    const section = demandValidation.find(x => x.section === currentDemandValidation);
    const editable = section ? section.editable : true;
    const ojsAdmin = section ? section.ojsAdmin : false;
    const downloadNoticeFromBzpEnabled = section ? !!section.downloadNoticeFromBzpEnabled : false;
    const processAsBzpNotice = section ? !!section.processAsBzpNotice : false;
    const [addBzpNoticePopupOpened, setAddBzpNoticePopupOpened] = useState(false);

    useEffect(() => {
        ResultNoticeService.getResultNotice(demandId);
        return () => {
            ResultNoticeService.clearResultNoticeResources();
        }
    }, [demandId, bzpTenderResultNoticeStatus])

    const goToNationalTenderResultNotice = () => {
        const href = RouterPath.createPath(RouterPath.myProcedure.steps.MP_NATIONAL_NOTICE_FORM_TYPE_ID, {formType: "resultNotice", id: demandId});
        RouterPath.redirect(href);
    }

    const getButtons = () => {
        const buttons = [];
        if (downloadNoticeFromBzpEnabled)
            buttons.push(createButton(Tr("add_bzp_result_notice"), () => setAddBzpNoticePopupOpened(true)));
        if (processAsBzpNotice) {
            const disabled = resultNotices[0].type === ResultNoticeType.BZP && resultNotices[0].attachments !== null && resultNotices[0].attachments.length > 0;
            buttons.push(createButton(Tr("bzp_tender_result_notice_create"), () => goToNationalTenderResultNotice(), disabled ? undefined :'outlined', disabled));
        }
        if (buttons.length)
            return <MultiButton buttons={buttons} justify="flex-start"/>
    }

    if (!resultNotices) return <Loading/>

    return (
        <Form
            initialValues={{}}
            validationSchema={ValidationShema.any()}
            id={DemandValidationKeys.RESULT_NOTICE}
        >{() =>
            (<div className={classes.root}>
                {getButtons()}

                <DemandValidationMessages editable={editable} section={section}/>
                {resultNotices[0].type === ResultNoticeType.BZP &&
                    <BzpResultNotice editable={editable} demandId={demandId} resultNotices={resultNotices} bzpResultNoticeSend={section.bzpResultNoticeSend} bzpResultNoticePublishedOnEzamowienia={section.bzpResultNoticePublishedOnEzamowienia}/>}
                {resultNotices[0].type === ResultNoticeType.ATTACHMENT &&
                    <AttachmentResultNotice editable={editable} demandId={demandId} resultNotice={resultNotices[0]}/>}
                {resultNotices[0].type === ResultNoticeType.OJS  &&
                    <OjsResultNotice
                        demandId={demandId}
                        editable={editable}
                        ojsAdmin={ojsAdmin}
                        resultNotice={resultNotices[0]}
                        canPublishOjsResultNotice={!!section && section.canPublishOjsResultNotice}
                        ojsResultNoticeSend={!!section && section.ojsResultNoticeSend}
                    />}

                {addBzpNoticePopupOpened && <AddBzpResultNoticePopup demandId={demandId} onClose={() => setAddBzpNoticePopupOpened(false)}/>}
            </div>)}
        </Form>
    )
}


export default connect((state) => ({
    resultNotices: state.resources[ResultNoticeService.RESULT_NOTICE_RESOURCE_ID],
    bzpTenderResultNoticeStatus: state.resources[NationalNoticeService.BZP_TENDER_RESULT_NOTICE_STATUS],
    demandValidation: state.resources.demandValidation
}), {})(withRouter(ResultNoticePanel));